const REVIEW_CHECK_INIT_URL = '/advert/review/check/init';
const REVIEW_CHECK_SEARCH_URL = '/advert/review/check/search';

const API_ADVERT_REVIEW_CHECK_NAME = 'apiAdvertReviewCheck';
const REDUCER_ADVERT_REVIEW_CHECK_NAME = 'advertReviewCheck';

export {
  REVIEW_CHECK_INIT_URL,
  REVIEW_CHECK_SEARCH_URL,

  API_ADVERT_REVIEW_CHECK_NAME,
  REDUCER_ADVERT_REVIEW_CHECK_NAME,
};
